define('commons/tap-coverage-map',['jquery', 'commons/coverage-map', 'commons/message-manager', 'utils/icons', 'utils/colors', 'commons/autocomplete', 'async!google-maps'], function($, CoverageMap,
        messages, icons, colors, Autocomplete) {
    var BaseStationCoverageMap = function(mapNodeId, options) {

        var opts = {
            minDb: 0,
            maxDb: 0,
            step1: 0,
            step2: 0,
            minColor: {
                h: 0,
                s: 0,
                b: 0
            },
            maxColor: {
                h: 0,
                s: 0,
                b: 0
            },
            captionOffset: {
                x: 15,
                y: -5
            },
            useTile: false,
            locationSearchInput: null,
            captionSelector: null,
            comStateSelector: null,
            disableTooltip: false,
            showCoverageOffsetBlock : false
        };
        $.extend(opts, options); 

        // Call the inherited coverage map constructor
        CoverageMap.call(this, mapNodeId, opts);

        // Create autocomplete search field
        var autocomplete = new Autocomplete(this.settings.locationSearchInput, this.map);

        this.oldMode =  $(this.settings.offsetSelector).val();

        // Canvas
        this.canvas = document.createElement('canvas');
        // Is canvas ready
        this.isCanvasReady = !!this.canvas.getContext;
        if(this.isCanvasReady) {
            this.canvasCtx = this.canvas.getContext("2d");
        }

        this.mapNodeId = mapNodeId;
        this.eventListenerMouseMove;
        this.eventListenerMouseOut;  
        this.event;

        // Create caption
        if (this.settings.captionSelector) {
            var coverageModeSelector = $(this.settings.captionSelector);

            var selectedCaption;
            var displayCaption = function(coverageModeSelector) {
                if (selectedCaption) {
                    selectedCaption.hide();
                }
                var selectedOption = coverageModeSelector.find(":selected");
                selectedCaption = $(".coverage-caption-" + selectedOption.data("caption"));
                selectedCaption.show();
            };

            if (this.settings.offsetSelector) {
                var coverageOffsetSelector = $(this.settings.offsetSelector);

                coverageModeSelector.change($.proxy(function(event) {
                    this.switchMode(coverageModeSelector.val(), coverageOffsetSelector.val() ? parseInt(coverageOffsetSelector.val()) : 0);
                    displayCaption(coverageModeSelector);
                    this.oldMode = coverageModeSelector.val();
                }, this));

                coverageOffsetSelector.change($.proxy(function() {
                    this.switchMode(coverageModeSelector.val(), coverageOffsetSelector.val() ? parseInt(coverageOffsetSelector.val()) : 0);
                }, this));
            } else if (this.settings.classSelector) {
                var coverageClassSelector = $(this.settings.classSelector);

                coverageModeSelector.change($.proxy(function() {
                    this.switchModeClass(coverageModeSelector.val(), coverageClassSelector.val());
                    displayCaption(coverageModeSelector);
                }, this));

                coverageClassSelector.change($.proxy(function() {
                    this.switchModeClass(coverageModeSelector.val(), coverageClassSelector.val());
                }, this));

            } else {
                coverageModeSelector.change($.proxy(function() {
                    this.switchMode(coverageModeSelector.val(), 0);
                    displayCaption(coverageModeSelector);
                }, this));
            }

            displayCaption(coverageModeSelector);
        }

        // comState selector
        if (this.settings.comStateSelector) {
            var comStateSelector = $(this.settings.comStateSelector);
            comStateSelector.change($.proxy(function() {
                this.filterByComState(comStateSelector.val());
            }, this));
        }

    };

    // Inherit from CoverageMap
    for ( var element in CoverageMap.prototype) {
        BaseStationCoverageMap.prototype[element] = CoverageMap.prototype[element];
    }

    BaseStationCoverageMap.prototype.getDbValue = function(hsb) {
        return ((hsb.h - this.settings.minColor.h) * (this.settings.maxDb - this.settings.minDb)) /
                (this.settings.maxColor.h - this.settings.minColor.h) + this.settings.minDb;
    };
    
    BaseStationCoverageMap.prototype.getMarginValue = function(hsb) {
        return ((hsb.h - this.settings.minColor.h) * (this.settings.maxDb - this.settings.minDb)) /
        (this.settings.maxColor.h - this.settings.minColor.h);
    };

    BaseStationCoverageMap.prototype.switchMode = function(mode, offset) {
        var displayOffset = offset;
        if (offset > 0 && (mode == "overlap_indoor" || mode == "overlap_underground")) {
            var step = this.settings.step1;
            if (mode == "overlap_underground") {
                step = this.settings.step2;
            }
            displayOffset += step;
            var limit = this.settings.maxDb - this.settings.minDb - step;
            if (limit < offset) {
                messages.warn("coverage can not be displayed in this mode with an offset over " + limit);
                mode = "none";
                offset = 0;
            }
        } else if (mode == "overlap_indoor" || mode == "overlap_underground") {
            var step = this.settings.step1;
            if (mode == "overlap_underground") {
                step = this.settings.step2;
            }
            displayOffset += step;
        }
        
        if (this.settings.showCoverageOffsetBlock && (mode == "simple" || mode == "full_margin" || mode == "overlap_outdoor" || mode == "overlap_indoor" || mode == "overlap_underground")) {
            $("#coverage-offset-block").show();
        } else {
            $("#coverage-offset-block").hide();
        }
        
        if (this.settings.useTile) {
            var mapDiv = $("#" + this.mapNodeId);
            if (mode == "full_margin" || mode =="full") {
                mapDiv.mousemove($.proxy(function(mouseEvent) {
                    this.event = mouseEvent;
                }, this));
                this.eventListenerMouseMove = this.map.addListener('mousemove', $.proxy(function(mouseEvent) {
                    this.onMouseMoveNew(mouseEvent);
                  }, this));
                this.eventListenerMouseOut = this.map.addListener('mouseout', $.proxy(function(mouseEvent) {
                    this.onMouseOutNew(mouseEvent);
                  }, this));
            } else {
                mapDiv.off('mousemove')
                if (this.eventListenerMouseMove) {
                    google.maps.event.removeListener(this.eventListenerMouseMove);
                }
                if (this.eventListenerMouseOut) {
                    google.maps.event.removeListener(this.eventListenerMouseOut);
                }
            }
        }

        if (mode == "progress" || this.oldMode == "progress") {
            if (this.settings.useTile) {
                this.removeTiles();
                if (mode == "progress") {
                    this.loadTiles([this.baseImgUrl, this.settings.densityBaseImgUrl], 0);
                } else {
                    this.loadTiles([this.baseImgUrl], 0);
                }
            }  else {
                var operatorSelector = $('#operators');
                var operatorId = operatorSelector.val() ? operatorSelector.val() : this.settings.operatorId; 
                $.ajax({
                    type: 'GET',
                    url: 'coverage/units/' + operatorId,
                    datatype: 'json',
                    data: {'progress':  this.oldMode != "progress"},
                    success: $.proxy(function(data) {
                        this._updateCoverages(data.coverage);
                    }, this)
                });
            }
        } else {
            if (this.settings.useTile) {
                this.loadTiles(null, displayOffset);
            }  else {
                var coverages = [];
                for ( var i in this.overlays) {
                    var overlay = this.overlays[i];
                    overlay.coverage.urlParams.mode = mode;
                    overlay.coverage.urlParams.offset = offset;
                    overlay.coverage.enableOver = (mode == "full" ||  mode == "full_margin");
                    coverages.push(overlay.coverage);
                }
                this.removeCoverages();
                this.addCoverages(coverages);
            }
        }
    };

    BaseStationCoverageMap.prototype.switchModeClass = function(mode, deviceClass) {
        if (this.settings.useTile) {
            var displayOffset = 0;
            if (mode == "overlap_indoor" || mode == "overlap_underground") {
                var step = this.settings.step1;
                if (mode == "overlap_underground") {
                    step = this.settings.step2;
                }
                displayOffset += step;
            }
            if (deviceClass != "U0") {
                if (deviceClass == "U1") {
                    displayOffset += 6;
                } else if (deviceClass == "U2") {
                    displayOffset += 11;
                } else if (deviceClass == "U3") {
                    displayOffset += 16;
                }
            }
            this.loadTiles(null, displayOffset);
        }  else {
            var coverages = [];
            for ( var i in this.overlays) {
                var overlay = this.overlays[i];
                overlay.coverage.urlParams.mode = mode;
                overlay.coverage.baseImgUrl = overlay.coverage.baseImgUrl;
                overlay.coverage.urlParams.deviceClass = deviceClass;
                overlay.coverage.enableOver = (mode == "full" ||  mode == "full_margin");
                coverages.push(overlay.coverage);
            }
            this.removeCoverages();
            this.addCoverages(coverages);
        }
    };

    BaseStationCoverageMap.prototype.filterByComState = function(comStateString) {
        for ( var id in this.markers) {
            var marker = this.markers[id];
            var isVisible = comStateString == "all" || (comStateString == "nok" && marker.markerInfo.comStateString != "ok") ||
                    (marker.markerInfo.comStateString == comStateString && comStateString != "none");

            this.updateMarkerVisibility(marker, isVisible);
        }
        this.redrawMarkers();
    };

    BaseStationCoverageMap.prototype.onToggleClusterClick = function(){
        CoverageMap.prototype.onToggleClusterClick.call(this);
        if (this.settings.comStateSelector) {
            var spotStateSelector = $(this.settings.comStateSelector);
            this.filterByComState(spotStateSelector.val());
        }
    };

    BaseStationCoverageMap.prototype.updateCoverageValues = function (minDb, maxDb) {
        this.settings.minDb = minDb;
        this.settings.maxDb = maxDb;
    };

    /**
     * @OVERRIDE
     */
    BaseStationCoverageMap.prototype._getIcon = function(markerInfo) {
        var locationSuffix = markerInfo.location == 0 ? '-outdoor' : '-indoor';
        var iconPrefix = markerInfo.iconPrefix;
        var stateSuffix = function () {
            switch (markerInfo.comStateString) {
                case "ok":
                    return '-green';
                case "ko":
                    return "-red";
                case "warn":
                    return '-orange';
                case "ok_ko":
                    return '-green-red';
                default:
                    return '-gray';
            }
        };

        return icons.mkIcon(iconPrefix + locationSuffix + stateSuffix());
    };

    /**
     * @OVERRIDE
     */
    BaseStationCoverageMap.prototype._getInfoContent = function(markerInfo) {
        return "<a href='/baseStation/" + markerInfo.id + "'>Base station id: " + markerInfo.hexId + "</a></p>" + "<p>Name: " + markerInfo.name + "</p>" +
                "<p>Last message: " + markerInfo.lastCom + "</p>" + "<p>Lat: " + markerInfo.lat + "</p>" + "<p>Lng: " + markerInfo.lng + "</p>";
    };

    /**
     * @OVERRIDE
     */
    BaseStationCoverageMap.prototype._onToolTipMove = function(event, pixel) {
        if (!this.settings.disableTooltip) {
            this.tooltip.css("display", pixel.a === 0 ? "none" : "block");
            this.tooltip.css("left", event.pageX + this.settings.captionOffset.x);
            this.tooltip.css("top", event.pageY + this.settings.captionOffset.y);
            this.tooltip.css("backgroundColor", "rgba(" + pixel.r + "," + pixel.g + "," + pixel.b + "," + pixel.a + ")");
            var hsb = colors.RGBToHSB(pixel.r, pixel.g, pixel.b);
            
            if ($(this.settings.captionSelector).val() == "full_margin") {
                this.tooltip.text(Math.round(this.getMarginValue(hsb)) + " dB");
            } else {
                this.tooltip.text(Math.round(this.getDbValue(hsb)) + " dBm");
            }
        }
    };
    
    BaseStationCoverageMap.prototype.onMouseMoveNew = function(event, a, b) {
        var pixel ={};
        // latLng to image coordinate into pixel
        // google coordinate point is a x and y decimal value from 0 to 256
        var point = this.map.getProjection().fromLatLngToPoint(event.latLng);
        var zoom = this.map.getZoom();
     
        // 1 point at z=11 , is 8 tile wide so 256 * 8 = 2048 pixels
        var ratio = 1;
        if (zoom < 11) {
            // for higher zoom level the image space taken is greater
            ratio = Math.pow(2, 11-zoom);
        }
        var coord = {};
        coord.tile = {};
        coord.tile.x = Math.floor(point.x * 8 / ratio);
        coord.tile.y = Math.floor(point.y * 8 / ratio);
        // retrieving the remainder (and multiplying by 256 to have pixel coordinate)
        coord.x = Math.floor((point.x * 8 / ratio - coord.tile.x) * 256);
        coord.y = Math.floor((point.y * 8 / ratio - coord.tile.y) * 256);
        // at zoom level 11 we keep image level 11 and zoom in
        coord.tile.z = Math.min(11, zoom);
        
        // retrieve pixel value from img 
        var imageKey = zoom + "_" + coord.tile.y + "_" + coord.tile.x;
        var img = this.getImage(imageKey);

        if (img && img.width) {
            this.canvasCtx.clearRect(0, 0, 1, 1);
            var startX = coord.x;
            var startY = coord.y;
            this.canvasCtx.drawImage(img, startX, startY, 1, 1, 0, 0, 1, 1);

            var raw = this.canvasCtx.getImageData(0, 0, 1, 1);
            var pixel = {
                p: {x: coord.x, y: coord.y},
                r: raw.data[0],
                g: raw.data[1],
                b: raw.data[2],
                a: raw.data[3]
            };

            this._onToolTipMove(this.event, pixel)
        }
    }

    BaseStationCoverageMap.prototype.onMouseOutNew = function(event) {
        this.tooltip.css("display", "none");
    }
    
    BaseStationCoverageMap.prototype._updateCoverages = function(units) {
        this.removeCoverages();
        this.loadCoverages(units);
    };

    return BaseStationCoverageMap;
});
